import { GRID_COLUMNS } from "src/cases/templates/caseBlocks/gridConstants";

type BackgroundGridProps = {
  rows: number;
};

export const BackgroundGrid: React.FC<BackgroundGridProps> = ({ rows }) => {
  const totalCells = GRID_COLUMNS * rows;

  return (
    <div
      className="pointer-events-none absolute inset-0 isolate z-0 grid auto-rows-[90px] grid-cols-6 gap-2"
      data-loc="case-blocks-background-grid"
    >
      {Array.from({ length: totalCells }).map((_, index) => (
        <div key={index} className="h-full rounded-lg bg-gray-50" />
      ))}
    </div>
  );
};
